module.exports = __webpack_public_path__ + "static/media/form-login.738540ae.png";